require('./inc/site.js');

// var contactFormContainer = undefined;

$(document).ready(function(){
  $('.navigation-link').click(function(e){
    if ($(this).attr('href') == 'javascript:void(0)') {
      setNavigationUrl($(this));
    }
  });

  $('.opening-hours-row .title-row').click(function(){
      var content = $(this).parents('.opening-hours-row').find('.content');
      $(this).toggleClass('opened');
      if (content && content.length > 0) {
        content.slideToggle();
      }
  });

  contactFormContainer = $('[data-purpose="contact-form-container"]');
  if (contactFormContainer && contactFormContainer.length > 0 && !contactFormContainer.is(':visible')) {
    $('[data-purpose="contact-form-opener"]').click(function(){
      if (!contactFormContainer.is(':visible')) {
        contactFormContainer.slideToggle();
        $('[data-purpose="contact-form-opener"]').off('click');
      }
    });
  }
});

function setNavigationUrl(item) {
  var address = item.data('address');

	if (address) {
		var protocol = 'google';
		var ua = navigator.userAgent.toLowerCase();
    var plat = navigator.platform;
		var device = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;

		if(device == 'iphone' || device == 'ipad' || device == 'ipod'){
			function iOSversion() {

				if (/iP(hone|od|ad)/.test(navigator.platform)) {
				  var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
				}
			}

			var ver = iOSversion() || [0];
			if (ver[0] >= 6) {
				protocol = 'apple';
			}
		}

		var urlSuffix = '/?daddr='+address;
		var nav_url = '';
		switch(protocol) {
			case 'apple':
				nav_url = 'maps://';
				break;
			default:
				nav_url = 'https://maps.google.com/maps';
				break;
		}
		item.attr('target', '_blank');
		item.attr('href', nav_url+urlSuffix);
	}
}
